import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useTranslation('common');

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/ad6561bce41cffafaeb86ff0d568a091.jpg"
          alt="Global Trade Network"
          className="w-full h-full object-cover object-top animate-[zoom_20s_ease-in-out_infinite_alternate]"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 text-center w-full">
        <div className={`mb-8 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-10'}`}>
          <span className="inline-block bg-[#14B8A6]/20 text-[#14B8A6] px-6 py-2 rounded-full text-sm font-medium border border-[#14B8A6]/30 animate-pulse">
            {t('hero.badge')}
          </span>
        </div>

        <h1 className={`text-white text-5xl lg:text-7xl font-bold mb-6 leading-tight transition-all duration-1000 delay-200 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          {t('hero.title1')}<br />
          <span className="text-[#14B8A6] inline-block animate-[glow_2s_ease-in-out_infinite]">{t('hero.title2')}</span>
        </h1>

        <p className={`text-gray-300 text-lg lg:text-xl mb-12 max-w-3xl mx-auto leading-relaxed transition-all duration-1000 delay-400 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          {t('hero.subtitle')}
        </p>

        <div className={`flex flex-wrap items-center justify-center gap-4 mb-16 transition-all duration-1000 delay-600 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <button className="bg-[#14B8A6] text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-[#0d9488] hover:scale-105 transition-all shadow-xl cursor-pointer whitespace-nowrap">
            {t('hero.cta1')}
          </button>
          <button className="bg-white/10 backdrop-blur-sm text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-white/20 hover:scale-105 transition-all border border-white/30 cursor-pointer whitespace-nowrap">
            {t('hero.cta2')}
          </button>
        </div>

        <div className={`grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto transition-all duration-1000 delay-800 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <a 
            href="https://cargillsonline.com" 
            target="_blank" 
            rel="noopener noreferrer"
            className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20 hover:bg-white/20 hover:scale-105 hover:-translate-y-2 transition-all duration-300 cursor-pointer"
          >
            <div className="flex items-center justify-center w-12 h-12 bg-[#14B8A6] rounded-full mb-4 mx-auto animate-[bounce_2s_ease-in-out_infinite]">
              <i className="ri-store-3-line text-white text-xl"></i>
            </div>
            <div className="text-[#14B8A6] text-3xl font-bold mb-2">{t('hero.stat1.number')}</div>
            <div className="text-white text-sm font-medium">{t('hero.stat1.title')}</div>
            <div className="text-gray-300 text-xs mt-1">{t('hero.stat1.subtitle')}</div>
          </a>

          <a 
            href="https://goldencoco.kr" 
            target="_blank" 
            rel="noopener noreferrer"
            className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20 hover:bg-white/20 hover:scale-105 hover:-translate-y-2 transition-all duration-300 cursor-pointer"
          >
            <div className="flex items-center justify-center w-12 h-12 bg-[#14B8A6] rounded-full mb-4 mx-auto animate-[bounce_2s_ease-in-out_infinite_0.3s]">
              <i className="ri-global-line text-white text-xl"></i>
            </div>
            <div className="text-[#14B8A6] text-3xl font-bold mb-2">{t('hero.stat2.number')}</div>
            <div className="text-white text-sm font-medium">{t('hero.stat2.title')}</div>
            <div className="text-gray-300 text-xs mt-1">{t('hero.stat2.subtitle')}</div>
          </a>

          <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20 hover:bg-white/20 hover:scale-105 hover:-translate-y-2 transition-all duration-300 cursor-pointer">
            <div className="flex items-center justify-center w-12 h-12 bg-[#14B8A6] rounded-full mb-4 mx-auto animate-[bounce_2s_ease-in-out_infinite_0.6s]">
              <i className="ri-robot-2-line text-white text-xl"></i>
            </div>
            <div className="text-[#14B8A6] text-3xl font-bold mb-2">{t('hero.stat3.number')}</div>
            <div className="text-white text-sm font-medium">{t('hero.stat3.title')}</div>
            <div className="text-gray-300 text-xs mt-1">{t('hero.stat3.subtitle')}</div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-2xl"></i>
      </div>
    </section>
  );
}
